import { Option } from 'src/components/tables/Cells/SelectCell'
import { roleTitleMap } from '../../domain/role'
import { RoleEnum } from '../../slices/services/api'

export const roleOptionsForAdminStoreManager: Option[] = [
  {
    value: String(RoleEnum.EditorStoreManager),
    title: roleTitleMap[RoleEnum.EditorStoreManager] ?? '',
  },
]

export const roleOptions: Option[] = [
  {
    value: String(RoleEnum.Admin),
    title: roleTitleMap[RoleEnum.Admin] ?? '',
  },
  {
    value: String(RoleEnum.AdminStoreManager),
    title: roleTitleMap[RoleEnum.AdminStoreManager] ?? '',
  },
  {
    value: String(RoleEnum.AdminSalesReportManager),
    title: roleTitleMap[RoleEnum.AdminSalesReportManager] ?? '',
  },
  {
    value: String(RoleEnum.EditorSalesReportManager),
    title: roleTitleMap[RoleEnum.EditorSalesReportManager] ?? '',
  },
  {
    value: String(RoleEnum.EditorStoreManager),
    title: roleTitleMap[RoleEnum.EditorStoreManager] ?? '',
  },
  {
    value: String(RoleEnum.Viewer),
    title: roleTitleMap[RoleEnum.Viewer] ?? '',
  },
]

export const editorSalesReportManagerIndex = 3

// '' = 全て / 'true' = 利用中 / 'false' = 利用停止
export type ActiveFilter = 'true' | 'false' | ''

export const activeOptions: Option[] = [
  {
    value: 'true',
    title: '利用中',
    color: 'green',
  },
  {
    value: 'false',
    title: '利用停止',
    color: 'gray',
  },
]
